// Botão "Copiar": copia um texto para a área de transferência e mostra "Copiado" por 1,5 s (com aviso para leitor de tela).
// Usado na linha de metadados de cada resposta (texto Markdown original) e no cabeçalho de cada bloco de código.
import { useEffect, useRef, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { toast } from './toast';
import '../styles/markdown.css';

/** `navigator.clipboard` (exige contexto seguro e permissão); sem ele, seleção + `execCommand('copy')`. */
export async function copyText(text: string): Promise<boolean> {
  try { await navigator.clipboard.writeText(text); return true; } catch { /* cai no plano B */ }
  const ta = document.createElement('textarea');
  ta.value = text; ta.setAttribute('readonly', ''); ta.setAttribute('aria-hidden', 'true');
  ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none';
  const prev = document.activeElement as HTMLElement | null;
  document.body.appendChild(ta);
  try { ta.select(); return document.execCommand('copy'); }
  catch { return false; }
  finally { ta.remove(); prev?.focus?.(); }
}

export function CopyButton({ text, label, className = '' }: { text: string; label: string; className?: string }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);
  const copy = async () => {
    if (!(await copyText(text))) { toast('não foi possível copiar', 'err'); return; }
    setCopied(true);
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), 1500);
  };
  return (
    <span className="copy-wrap">
      <button type="button" className={`copy-btn${copied ? ' ok' : ''} ${className}`.trim()} aria-label={label} onClick={() => void copy()}>
        {copied ? <Check /> : <Copy />}<span>{copied ? 'Copiado' : 'Copiar'}</span>
      </button>
      <span className="sr-only" role="status" aria-live="polite">{copied ? 'Copiado' : ''}</span>
    </span>
  );
}
